// Setup globale di dayjs.
//
// Sostituisce moment (-290 KB). Estende il default export con i plugin
// usati nel codebase, imposta la locale italiana e lo esporta come
// drop-in `dayjs` per i 86 file che lo usavano.
//
// IMPORTANTE: dayjs è immutabile. Pattern come `m.add(1, 'day')` che in
// moment mutano l'oggetto, in dayjs creano un NUOVO oggetto. Tutti gli
// usi mutating vanno riassegnati: `let d = dayjs(); d = d.add(1, 'day');`.
// I bug runtime conseguenti sono difficili da rilevare staticamente —
// vanno verificati interagendo con l'app.

import dayjs from 'dayjs';
import 'dayjs/locale/it';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isoWeek from 'dayjs/plugin/isoWeek';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import minMax from 'dayjs/plugin/minMax';
import objectSupport from 'dayjs/plugin/objectSupport';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isoWeek);
dayjs.extend(localizedFormat);
dayjs.extend(minMax);
dayjs.extend(objectSupport);
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(weekOfYear);

dayjs.locale('it');

export default dayjs;
